<div class="page-container">
  <app-theme-toggle class="auth-theme-toggle" />
  <div class="center-column">
    <div class="content-container">
      <div class="auth-brand">
        <app-mira-logo class="auth-brand-logo" [width]="48" [height]="48" />
        <span class="auth-brand-name"><span class="auth-brand-box">box</span><span class="auth-brand-dot">.</span><span class="auth-brand-moe">moe</span></span>
      </div>
      <header>Recover your account</header>
      <app-flow [flow]="flow" (submit)="onSubmit($event)"></app-flow>
      <div class="action">
        <a routerLink="/">Go back</a>
      </div>
    </div>
  </div>
</div>
